import React from 'react';
import { Button, ButtonType, ColorType } from '~/components/elements/buttons/Button';
const CallToAction = ({ heading, url, label, }) => {

    return (
        <div className="text-center flex flex-col justify-center mb-[48px] md:mb-[73px]">
            {heading && <h3 className="text-h3 mb-[31px]">{heading}</h3>}
            <div className="flex justify-center">
                <Button link={{ url: url, title: label }} type={ButtonType.Button} color={ColorType.Blue} />
            </div>
        </div>
    );
};

export default CallToAction;
